/* components/patterns/PageHeader.jsx — sticky-шапка раздела.
   Слоты: hamburger (tablet) · title + subtitle · tabs (опц.) · actions.
   Не перекрывается оверлеями (z-sticky < z-overlay). Источник: 02-IA §5. */

import React from 'react';
import { useShell } from '../../app/layouts/AppShell.jsx';
import { LearnHubButton } from '../../app/onboarding/module1/LearnHubButton.jsx';
import { useAuth } from '../../app/providers/AuthProvider.jsx';
import { useBp } from '../../app/providers/BreakpointProvider.jsx';
import { NotificationsBell } from './notifications/NotificationsBell.jsx';
import { SupportButton } from './SupportButton.jsx';
import { Breadcrumbs } from './Breadcrumbs.jsx';
import { Icon } from '../ui/Icon.jsx';
import { RR } from '../../lib/router.jsx';

  const { useRef, useState, useEffect, useCallback } = React;
  const { NavLink, useLocation } = RR;

  // горизонтальные вкладки с edge-fade (03-adaptive §391): градиент у краёв,
  // переключаемый по фактической прокрутке (.scroll-row-wrap.fade-l/.fade-r).
  function ScrollTabs({ tabs, activeTab, onTab }) {
    const rowRef = useRef(null);
    const [fade, setFade] = useState({ l: false, r: false });
    const update = useCallback(() => {
      const el = rowRef.current;
      if (!el) return;
      const maxScroll = el.scrollWidth - el.clientWidth;
      setFade({ l: el.scrollLeft > 1, r: el.scrollLeft < maxScroll - 1 });
    }, []);
    useEffect(() => {
      update();
      window.addEventListener('resize', update);
      return () => window.removeEventListener('resize', update);
    }, [update, tabs]);
    const cls = 'scroll-row-wrap' + (fade.l ? ' fade-l' : '') + (fade.r ? ' fade-r' : '');
    return (
      <div className={cls}>
        <div className="page-header__tabs scroll-row" role="tablist" ref={rowRef} onScroll={update}>
          {tabs.map((t) => (
            <button key={t.id} role="tab" aria-selected={activeTab === t.id} data-onb={t.onb}
              className={'seg-tab' + (activeTab === t.id ? ' is-active' : '')}
              onClick={() => onTab && onTab(t.id)}>
              {t.label}
              {t.count != null && <span className="seg-tab__count num">{t.count}</span>}
            </button>
          ))}
        </div>
      </div>
    );
  }

  function PageHeader({ title, subtitle, breadcrumbs, tabs, activeTab, onTab, actions }) {
    const shell = useShell ? useShell() : { showHamburger: false, openNav: () => {} };
    const location = useLocation();
    const bp = useBp ? useBp().bp : 'lg';
    const auth = useAuth ? useAuth() : null;
    // колокол есть везде в шапке раздела, КРОМЕ страницы /notifications (фикс дублирования)
    const showBell = NotificationsBell && location.pathname !== '/notifications';
    // «Поддержка» — та же логика, что у колокола: везде, кроме своей же страницы.
    // На xs в шапке тесно — там вход пунктом «Поддержка» в шторке «Ещё».
    const showSupport = bp !== 'xs' && location.pathname !== '/support';
    const showWorkspace = !!(auth && auth.workspaces && auth.workspaces.length > 1);
    return (
      <header className="page-header">
        <div className="page-header__bar">
          {shell.showHamburger && (
            <button className="page-header__menu" onClick={shell.openNav} aria-label="Меню">
              <Icon name="menu" size={20} />
            </button>
          )}
          <div className="page-header__titles grow">
            {breadcrumbs && breadcrumbs.length
              ? <Breadcrumbs items={breadcrumbs} className="page-header__eyebrow" />
              : subtitle && <div className="page-header__eyebrow t-eyebrow">{subtitle}</div>}
            <h1 className="page-header__title t-h2 truncate">{title}</h1>
          </div>
          <div className="page-header__actions cluster cluster-4">
            {actions}
            {/* «шляпа студента» — хаб обучения (демо-CJM); вне auth рендерит null */}
            <LearnHubButton />
            {showSupport && <SupportButton bp={bp} />}
            {showBell && <NotificationsBell bp={bp} showWorkspace={showWorkspace} />}
          </div>
        </div>
        {tabs && tabs.length > 0 && (
          <ScrollTabs tabs={tabs} activeTab={activeTab} onTab={onTab} />
        )}
      </header>
    );
  }

export { PageHeader };
